import React, { useState, useEffect } from "react";
import styles from "./RoomAssignmentBar.module.css";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { useIsMountedRef } from "hooks/useIsMountedRef";
import { RoomAssignment } from "store/user/types";

export const RoomAssignmentBar: React.FC = () => {
  const isMountedRef = useIsMountedRef();
  const { roomAssignment, isInteracting } = useSelector(
    (s: RootState) => s.user
  );
  const [lastChangedRoomAssignment, setLastChangedRoomAssignment] = useState<
    RoomAssignment
  >();
  const [showOnRoomChange, setShowOnRoomChange] = useState(false);

  useEffect(() => {
    if (roomAssignment !== lastChangedRoomAssignment) {
      setLastChangedRoomAssignment(roomAssignment);
      if (!showOnRoomChange) {
        setShowOnRoomChange(true);
        setTimeout(() => {
          if (isMountedRef.current) {
            setShowOnRoomChange(false);
          }
        }, 5000);
      }
    }
  }, [
    showOnRoomChange,
    isMountedRef,
    roomAssignment,
    lastChangedRoomAssignment,
  ]);

  return (
    <div
      className={`${styles["bar"]} ${
        isInteracting || showOnRoomChange ? styles["show"] : ""
      }`}
    >
      {roomAssignment === RoomAssignment.GreenRoom ? (
        <p>
          You're in the <span style={{ color: "#7dff7d" }}>Green Room</span>.
        </p>
      ) : (
        <p>
          You're in the <span style={{ color: "#ff8c8c" }}>Live Room</span>.
        </p>
      )}
    </div>
  );
};
